// React and firebase components
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import firebase from "firebase/app";
import db from "../firebase";
// Components for different pages
import NavBar from "./NavBar";
import SponsoredPosts from "./LandingPage/SponsoredPosts";
import PostsAndSideBar from "./LandingPage/PostsAndSideBar";
import About from "./About";
import Contact from "./Contact";
import Post from "./Article/Post";
import Author from "./AuthorPortfolio/Author";
import AdminPanel from "./Admin Panel/AdminPanel";
import { SignIn } from "./auth/SignIn";
import Compose from "./Compose/Compose";
import EditBlog from "./Edit Blog/EditBlog";
import EditAuthor from "./Admin Panel/EditAuthor";
import Error404 from "./Error404";

function App() {
  const [adminPermission, setAdminPermission ] = useState(false);
  const auth = firebase.auth();
  const [user] = useAuthState(auth);
  // Check the manual admin permission fo the signed in user
  useEffect(() => {
    db.collection("authors").where("uid", "!=", "Not permitted").get().then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
        // If the uid of signed In user === uid of the author set by founder then the signed In user is an admin
        if(user && user.uid === doc.data().uid) { setAdminPermission(true); }
      })
    })
  });

  return (
    <Router>
      <div className="App">
        <NavBar />
        <Switch>
          <Route exact path="/">
            <SponsoredPosts />
            <PostsAndSideBar />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/posts/:title">
            <Post />
          </Route>
          <Route path="/authors/:name">
            <Author />
          </Route>
          <Route path="/admin/posts">
            {(user && adminPermission) ? <AdminPanel username={user.displayName} /> : <SignIn />}
          </Route>
          <Route path="/admin/compose">
            {(user && adminPermission) ? <Compose username={user.displayName} /> : <SignIn />}
          </Route>
          <Route path="/admin/editPost/:blogTitle">
            {(user && adminPermission) ? <EditBlog username={user.displayName} /> : <SignIn />}
          </Route>
          <Route path="/admin/authors/:authorName">
            {(user && adminPermission) ? <EditAuthor username={user.displayName} /> : <SignIn />}
          </Route>
          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
